// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tp8x","toggleWrap":"styles_toggleWrap__2dgpe","content":"styles_content__2jWS_","selectAreaCode":"styles_selectAreaCode__3m_3p"};